import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const HireWithoutBreakingBank = () => {
  return <CommingSoon />;
};

export default HireWithoutBreakingBank;
